import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container content-frame" }
const _hoisted_2 = { class: "row list-table-row" }
const _hoisted_3 = { class: "col table-wrap" }
const _hoisted_4 = {
  key: 0,
  class: "table"
}
const _hoisted_5 = { class: "row button-row justify-content-md-end" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogFrame = _resolveComponent("DialogFrame")!

  return (_openBlock(), _createBlock(_component_DialogFrame, {
    "show-dialog": _ctx.show,
    "on-click-close": _ctx.close,
    title: '支店側で承認するスタッフ一覧',
    height: '90%',
    width: '90%'
  }, {
    dialogContent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.affectedList.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "スタッフID"),
                      _createElementVNode("th", null, "スタッフ名")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affectedList, (staff) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: staff.vForKey
                      }, [
                        _createElementVNode("td", null, _toDisplayString(staff.staffId), 1),
                        _createElementVNode("td", null, _toDisplayString(staff.displayName), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "empty-table-text wrap-text",
                  style: _normalizeStyle({fontSize: _ctx.FontSizes.large1})
                }, "支店による一斉承認を行うスタッフはいません", 4))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-outline-info col col-md-4 align-self-center mx-1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, "キャンセル"),
          _createElementVNode("button", {
            class: "btn btn-info col col-md-4 align-self-center mx-1",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickApproveByBranch && _ctx.onClickApproveByBranch(...args))),
            disabled: !_ctx.canClickApprovalByBranch()
          }, "承認する", 8, _hoisted_6)
        ])
      ])
    ]),
    _: 1
  }, 8, ["show-dialog", "on-click-close"]))
}